import { createLoop, createSvgElement, mulberry32, pointerTracker } from "./shared.js";

function svgBird(id) {
  return createSvgElement("path", {
    d: "M-10 1 Q-4 -8 0 0 Q5 -9 11 1 Q5 -2 0 4 Q-5 -2 -10 1Z",
    fill: id % 6 === 0 ? "#b3372b" : "#17140f",
  });
}

export function mountYanfan(root, settings) {
  const shell = document.createElement("div");
  shell.className = "svg-stage yanfan-stage";
  const svg = createSvgElement("svg", { viewBox: "0 0 800 1000", role: "img", "aria-label": "文字化作飞燕的互动纸面" });
  const paper = createSvgElement("rect", { x: 80, y: 70, width: 640, height: 860, rx: 2, fill: "#e9e1ce", stroke: "#827866" });
  svg.append(paper);
  const lines = [
    "THE WORDS LEARN THE SHAPE OF AIR",
    "AND LEAVE THE PAPER ONE BY ONE.",
    "A RED FISH CROSSES THE MARGIN;",
    "THE BIRDS REMEMBER THEIR PLACES.",
    "MOVE SLOWLY. THE LETTERS RETURN.",
  ];
  lines.forEach((line, index) => {
    const text = createSvgElement("text", {
      x: 140,
      y: 210 + index * 52,
      fill: "#3a342b",
      "font-size": 18,
      "font-family": "Courier New, monospace",
      "letter-spacing": 2,
    });
    text.textContent = line;
    svg.append(text);
  });
  const fish = createSvgElement("path", {
    d: "M0 0 C34 -26 74 -18 96 0 C74 18 34 26 0 0 M4 0 L-30 -22 L-24 0 L-30 22Z",
    fill: "#b3372b",
  });
  svg.append(fish);
  const random = mulberry32(settings.seed + 11);
  const flock = Array.from({ length: Math.round(48 * settings.density) }, (_, index) => {
    const bird = svgBird(index);
    svg.append(bird);
    return {
      node: bird,
      homeX: 150 + (index % 12) * 43,
      homeY: 520 + Math.floor(index / 12) * 42,
      phase: random() * Math.PI * 2,
      radius: 60 + random() * 180,
    };
  });
  shell.append(svg);
  root.append(shell);
  const pointer = pointerTracker(shell);

  return createLoop((_, time) => {
    const targetX = pointer.active ? pointer.x * 800 : 400 + Math.cos(time * 0.55) * 220;
    const targetY = pointer.active ? pointer.y * 1000 : 500 + Math.sin(time * 0.72) * 240;
    fish.setAttribute("transform", `translate(${targetX - 45} ${targetY}) rotate(${Math.sin(time) * 8})`);
    flock.forEach((bird, index) => {
      const active = pointer.active || Math.sin(time * 0.38 + bird.phase) > -0.35;
      const mix = active ? 1 : 0.08;
      const x = bird.homeX * (1 - mix) + (targetX + Math.cos(time * (0.65 + (index % 5) * 0.03) + bird.phase) * bird.radius) * mix;
      const y = bird.homeY * (1 - mix) + (targetY + Math.sin(time * 0.82 + bird.phase) * bird.radius * 0.62) * mix;
      const angle = Math.sin(time * 1.4 + bird.phase) * 20;
      const wing = 0.7 + Math.sin(time * 8 + bird.phase) * 0.22;
      bird.node.setAttribute("transform", `translate(${x} ${y}) rotate(${angle}) scale(${wing} 1)`);
    });
  }, settings);
}

export function mountTyping(root, settings) {
  const shell = document.createElement("div");
  shell.className = "typing-stage";
  shell.innerHTML = `
    <div class="typing-paper" aria-live="polite">
      <div class="typing-margin"></div>
      <div class="typing-copy" id="typing-copy"></div>
      <svg class="typing-flight" viewBox="0 0 800 1000" aria-hidden="true"></svg>
    </div>
    <div class="typewriter">
      <div class="typewriter-slot"></div>
      <div class="typewriter-keys" aria-hidden="true"></div>
    </div>
    <p class="typing-hint">直接敲键盘 · 每个字符都会放飞一只鸟</p>`;
  root.append(shell);
  const keys = shell.querySelector(".typewriter-keys");
  "QWERTYUIOPASDFGHJKLZXCVBNM".split("").forEach((key) => {
    const span = document.createElement("span");
    span.textContent = key;
    keys.append(span);
  });
  const copy = shell.querySelector("#typing-copy");
  const flight = shell.querySelector(".typing-flight");
  const phrase = "TYPE INTO THE AIR";
  let value = "";
  let cursor = 0;
  let timer = 0;

  const launch = (char) => {
    value = `${value}${char}`.slice(-72);
    copy.textContent = value;
    const path = createSvgElement("path", {
      d: "M-10 1 Q-4 -8 0 0 Q5 -9 11 1 Q5 -2 0 4 Q-5 -2 -10 1Z",
      fill: "#17140f",
    });
    const x = 170 + (value.length % 15) * 30;
    const y = 680 - Math.floor((value.length % 60) / 15) * 48;
    path.setAttribute("transform", `translate(${x} ${y})`);
    flight.append(path);
    const dx = (Math.random() - 0.5) * 420;
    const dy = -220 - Math.random() * 320;
    path.animate(
      [
        { transform: `translate(${x}px, ${y}px) rotate(0deg) scale(.55)`, opacity: 0.95 },
        { transform: `translate(${x + dx * 0.35}px, ${y + dy * 0.7}px) rotate(${dx * 0.08}deg) scale(1.1)`, opacity: 1, offset: 0.62 },
        { transform: `translate(${x + dx}px, ${y + dy}px) rotate(${dx * 0.12}deg) scale(.7)`, opacity: 0 },
      ],
      { duration: 2100 / settings.speed, easing: "cubic-bezier(.16,1,.3,1)" },
    ).onfinish = () => path.remove();
  };
  const onKey = (event) => {
    if (event.key.length === 1 && !event.metaKey && !event.ctrlKey) launch(event.key.toUpperCase());
    if (event.key === "Backspace") {
      value = value.slice(0, -1);
      copy.textContent = value;
    }
  };
  window.addEventListener("keydown", onKey);
  const stop = createLoop((dt) => {
    timer += dt;
    if (timer > 0.72) {
      launch(phrase[cursor++ % phrase.length]);
      timer = 0;
    }
  }, settings);
  return () => {
    stop();
    window.removeEventListener("keydown", onKey);
  };
}

export function mountRain(root, settings) {
  const shell = document.createElement("div");
  shell.className = "rain-stage";
  shell.innerHTML = `
    <svg width="0" height="0" aria-hidden="true">
      <filter id="rain-distort">
        <feTurbulence type="fractalNoise" baseFrequency=".008 .12" numOctaves="2" seed="${settings.seed}" result="noise"/>
        <feDisplacementMap in="SourceGraphic" in2="noise" scale="18" xChannelSelector="R" yChannelSelector="G"/>
      </filter>
    </svg>
    <div class="rain-city">
      <i></i><i></i><i></i><i></i><i></i><i></i><i></i>
    </div>
    <div class="rain-blur"></div>
    <div class="rain-drops" aria-hidden="true"></div>
    <div class="rain-wipe" aria-hidden="true"></div>
    <p class="rain-label">DRAG TO CLEAR / 雨夜</p>`;
  root.append(shell);
  const drops = shell.querySelector(".rain-drops");
  const random = mulberry32(settings.seed + 8);
  Array.from({ length: Math.round(95 * settings.density) }).forEach((_, index) => {
    const drop = document.createElement("i");
    const size = 3 + random() * 10;
    drop.style.cssText = `--x:${random() * 100}%;--y:${random() * 100}%;--s:${size}px;--d:${2 + random() * 5}s;--delay:${-random() * 7}s`;
    if (index % 11 === 0) drop.classList.add("runner");
    drops.append(drop);
  });
  const wipe = shell.querySelector(".rain-wipe");
  const pointer = pointerTracker(shell);
  return createLoop(() => {
    if (pointer.active) {
      wipe.style.setProperty("--wipe-x", `${pointer.x * 100}%`);
      wipe.style.setProperty("--wipe-y", `${pointer.y * 100}%`);
      wipe.classList.add("active");
    } else {
      wipe.classList.remove("active");
    }
  }, settings);
}
